// Auto-generated from translation.csv; do not edit manually
export const frFR = {
  "accountGuide": {
    "content": "Ouvrez n'importe quel jeu du groupe Touka, allez dans les paramètres du jeu, liez votre email, et profitez des offres spéciales !",
    "title": "Comment créer un compte ?"
  },
  "bottomNav": {
    "home": "Accueil",
    "myOrders": "Mes commandes"
  },
  "common": {
    "loading": "Chargement...",
    "noData": "Aucune donnée",
    "server": "Serveur"
  },
  "auth": {
    "tokenExpired": "Connexion expirée"
  },
  "errors": {
    "900400": "Erreur de paramètre interne",
    "900401": "Échec de l'authentification",
    "900402": "Connexion expirée",
    "1000000": "Erreur système. Veuillez réessayer plus tard",
    "1000001": "Erreur de paramètre système. Veuillez réessayer plus tard",
    "1000002": "L'ID ou le code captcha ne peut pas être vide",
    "1000003": "E-mail invalide",
    "1000004": "Code captcha invalide",
    "1000005": "Le code e-mail a déjà été envoyé. Veuillez patienter 1 minute puis réessayer",
    "1000006": "Limite d'envoi de code atteinte. Veuillez réessayer demain",
    "1000007": "L'e-mail ne peut pas être vide",
    "1000008": "Le code ne peut pas être vide",
    "1000009": "Code invalide",
    "1000010": "Erreur lors de l'obtention du token de connexion",
    "1000011": "Le produit est inactif. Veuillez sélectionner un autre produit",
    "1000012": "Le produit a dépassé la limite d'achat. Veuillez sélectionner un autre produit",
    "1000013": "Le produit a été retiré",
    "1000014": "Méthode de paiement non activée",
    "1000015": "Votre compte ne prend pas en charge l'achat de produits. Veuillez contacter le service client",
    "1000016": "Échec de la création de la commande. Veuillez réessayer",
    "1000017": "Cette commande ne peut pas être annulée",
    "1000018": "La limite de quantité pour un achat unique a été atteinte",
    "1000019": "Le code de vérification a expiré. Veuillez en demander un nouveau"
  },
  "footer": {
    "language": "Chinois (simplifié)",
    "privacyPolicy": "Politique de confidentialité",
    "refundPolicy": "Politique de remboursement",
    "termsOfService": "Conditions de service",
    "userSupport": "Support utilisateur",
    "downloadNow": "Télécharger maintenant !"
  },
  "header": {
    "characterName": "Nom du personnage",
    "gameServer": "Serveur de jeu",
    "selectGameServer": "Sélectionner la région du jeu",
    "greeting": "Bonjour",
    "loginPrompt": "Veuillez cliquer pour vous connecter",
    "switchServer": "Changer",
    "title": "Centre de recharge du jeu",
    "logout": "Se déconnecter"
  },
  "games": {
    "bamBamSquad": "BamBamSquad",
    "oopsieCroco": "Oopsie Croco"
  },
  "history": {
    "backToGameZone": "Retour à la boutique du jeu",
    "allGames": "Tous les jeux",
    "empty": "Pas de commandes pour le moment",
    "filter": {
      "all": "Tout",
      "closed": "Fermé",
      "completed": "Terminé",
      "inProgress": "En cours",
      "pendingDelivery": "En attente d'expédition"
    },
    "orderTime": "Heure de commande:",
    "pendingAutoCancelPrefix": "La commande sera annulée dans",
    "pendingAutoCancelSuffix": "automatiquement",
    "cancelOrder": "Annuler la commande",
    "payOrder": "Payer",
    "cancelOrderConfirmTitle": "Annuler la commande ?",
    "cancelOrderConfirmPrimary": "Confirmer",
    "cancelOrderDismiss": "Pas maintenant",
    "previousPage": "Précédent",
    "nextPage": "Suivant",
    "status": {
      "cancelled": "Annulé",
      "completed": "Transaction terminée",
      "paid": "Payé",
      "pending": "En attente de paiement",
      "shipped": "Expédié"
    }
  },
  "home": {
    "selectGame": "Choisissez le jeu que vous souhaitez recharger",
    "selectGameMobileTitle": "Choisir un jeu à recharger",
    "selectGameParts": {
      "prefix": "Choisissez le jeu auquel vous souhaitez ",
      "keyword": "recharger",
      "suffix": ""
    },
    "noRoleAccount": "Vous n'avez pas encore de personnage dans ce jeu. Veuillez en créer un dans le jeu avant d'acheter.",
    "noRoleRefreshPrefix": "Compte déjà créé ? Appuyez sur ",
    "noRoleRefreshAction": "Actualiser",
    "noRoleRefreshing": "Actualisation…",
    "noRoleRefreshNotFound": "Aucune information de personnage trouvée",
    "noRoleRefreshFailed": "Échec de l’actualisation. Veuillez réessayer plus tard."
  },
  "login": {
    "agreeTerms": {
      "and": "et",
      "prefix": "J'ai lu et accepte",
      "privacy": "Politique de confidentialité",
      "terms": "Conditions de service"
    },
    "cancel": "Annuler",
    "bindGameGuide": "Notice de liaison au jeu",
    "bindGameGuideContent": "Ouvrez n’importe quel jeu Touka,\nallez dans les paramètres du jeu,\nliez votre adresse e-mail\net profitez des promotions sur la boutique !",
    "captchaPlaceholder": "Code de vérification",
    "invalidCaptcha": "Veuillez saisir un code de vérification à 4 chiffres",
    "email": "Email",
    "emailNotBound": "Nous n'avons pas trouvé le compte. Veuillez saisir l'adresse e-mail liée à votre compte de jeu~",
    "emailPlaceholder": "Veuillez entrer votre adresse email",
    "keepLogin": "Rester connecté pendant 15 jours",
    "loading": "Connexion en cours...",
    "loginToStore": "Connexion à Touka Store",
    "noAccount": "Pas encore de compte ?",
    "password": "Mot de passe",
    "passwordPlaceholder": "Veuillez entrer le mot de passe",
    "submit": "Se connecter",
    "title": "Se connecter",
    "invalidEmail": "Veuillez saisir une adresse e-mail valide"
  },
  "logout": {
    "cancel": "Annuler",
    "confirm": "Confirmer",
    "dontRemind": "Ne plus rappeler la prochaine fois",
    "messageLine1": "Après la déconnexion, l'état de connexion sur tous les appareils utilisés au cours des 30 derniers jours",
    "messageLine2": "sera réinitialisé.",
    "title": "Avis"
  },
  "menu": {
    "contactSupport": "Contacter le service client",
    "gameList": "Liste des jeux",
    "myOrders": "Mes commandes"
  },
  "paymentSuccess": {
    "account": "Compte :",
    "celebrationTitle": "Achat réussi",
    "confirm": "Confirmer",
    "getPaymentInfoFailed": "Échec de l'obtention des informations de paiement",
    "loading": "Chargement...",
    "orderDate": "Date de la commande :",
    "orderId": "Numéro de commande :",
    "paymentMethod": "Mode de paiement :",
    "paypal": "PayPal",
    "price": "Prix :",
    "purchaseContent": "Contenu de l'achat :",
    "quantity": "Quantité achetée :",
    "serverAndCharacter": "Serveur / Personnage :",
    "title": "Merci pour l'achat",
    "total": "Total :",
    "unionPay": "UnionPay",
    "amountPaid": "Montant payé :",
    "closeModal": "Fermer"
  },
  "productModal": {
    "confirm": "Confirmer",
    "purchaseDetails": "Détails de l'achat",
    "quantity": "Quantité :",
    "total": "Total :",
    "unitPrice": "Prix unitaire :"
  },
  "products": {
    "giftPacks": "Pack cadeau",
    "diamond": "Diamant",
    "products": "Produit",
    "vouchers": "Coupon",
    "toukaCoin": "Touka Coin",
    "toukaCoinBonusTip": "Achetez sur TOUKA Store et profitez de 10 % de bonus supplémentaire !",
    "superValue": "Super offre",
    "limitShort": "Limite",
    "remainingShort": "Temps rest.",
    "giftPackLimitType": {
      "lifetime": "Offre à vie",
      "weekly": "Offre hebdo",
      "monthly": "Offre mensuelle"
    },
    "howToUseVouchers": "Comment utiliser les coupons ?",
    "voucherGuide": {
      "title": "Comment utiliser les coupons ?",
      "step1": "1. Veuillez vérifier votre boîte aux lettres en jeu pour récupérer les coupons que vous avez achetés.",
      "step2": "2. Vous pouvez consulter le nombre de vos coupons en haut de l'onglet de la boutique du jeu. Lorsque vous avez suffisamment de coupons pour acheter un pack cadeau, ils seront utilisés en priorité lors de l'achat.",
      "backToProducts": "Retour à la liste des produits"
    },
    "luxuryVouchers": "Coupons premium"
  },
  "purchaseConfirm": {
    "card": "Carte de crédit / Carte de débit",
    "confirm": "Confirmer",
    "dontAskAgain": "Ne plus demander dans les 30 jours",
    "gameServer": "Serveur de jeu",
    "paymentMethods": "Modes de paiement pris en charge",
    "paypal": "PayPal ",
    "title": "Êtes-vous sûr de vouloir effectuer cet achat avec ce compte ?",
    "unionPay": "Carte UnionPay "
  },
  "serverSelect": {
    "characterLabel": "Nom du personnage ",
    "characterPlaceholder": "Veuillez sélectionner un personnage ",
    "confirm": "Confirmer ",
    "noResults": "Aucun résultat pour le moment ",
    "serverPlaceholder": "Veuillez saisir le nom du serveur pour rechercher",
    "title": "Sélectionner le serveur de jeu"
  },
  "orientation": {
    "bestExperience": "Passez en mode portrait pour une meilleure expérience"
  },
  "support": {
    "cancel": "Annuler ",
    "copied": "Copié ",
    "copy": "Copie en un clic ",
    "description": "Veuillez envoyer vos informations détaillées à l'adresse e-mail officielle du support.",
    "title": "Support client "
  },
  "verification": {
    "back": "Retour ",
    "enterCode": "Veuillez saisir le code de vérification pour continuer ",
    "incorrectCode": "Code de vérification incorrect ",
    "invalidCode": "Veuillez saisir un code de vérification à 6 chiffres ",
    "noCode": "Vous ne recevez pas le code de vérification ? ",
    "sentTo": "Le code de vérification a été envoyé à",
    "submit": "Soumettre ",
    "submitting": "Soumission en cours..."
  }
} as const;
